<script setup lang="ts">
import { useForm } from 'vee-validate'
import { toTypedSchema } from '@vee-validate/zod'
import UiModal from '@boats/ui/components/UiModal.vue'
import { z } from 'zod'
import { fetchApi } from '~/queries'

const modals = useModalsStore()
const auth = useAuthStore()

const validationSchema = toTypedSchema(
  z.object({
    name: z.string().min(1, 'Required'),
    email: z.string().email('Invalid email'),
    number_of_tickets: z.number().min(0, 'Required'),
    message: z.string().min(1, 'Required')
  })
)

const { defineField, errors, validate } = useForm({
  validationSchema
})

const [name, nameAttrs] = defineField('name')
const [email, emailAttrs] = defineField('email')
const [numberOfTickets, numberOfTicketsAttrs] = defineField('number_of_tickets')
const [message, messageAttrs] = defineField('message')

if (auth.user) {
  name.value = auth.user.firstName + ' ' + auth.user.lastName
  email.value = auth.user.emailAddress
}
numberOfTickets.value = 2

const onSubmit = async () => {
  const result = await validate()
  if (!result.valid) return

  const payload = {
    ...result.values,
    url: window.location.href
  }

  await fetchApi(`/clients/contact-us`, {
    method: 'POST',
    body: JSON.stringify(payload)
  })

  modals.closeContactUsModal()
}


</script>


<template>
  <UiModal
    v-model="modals.isContactUsModalOpen"
    class="app-modal-contact-us"
    @close="modals.closeContactUsModal"
  >
    <AppTextField
      v-model="name"
      full-width
      class="mb-3 md:mb-4"
      v-bind="nameAttrs"
      :error="!!errors.name"
      :placeholder="$t('string.Name')"
    />

    <AppTextField
      full-width class="mb-3 md:mb-4"
      v-model="email"
      v-bind="emailAttrs"
      :error="!!errors.email"
      :placeholder="$t('component.newsletter.label.email')"
    />
    <div class="mb-3 md:mb-4">
      <div class="text-center">{{ $t('component.tickets.show.quantity.label') }}</div>
      <AppInputQuantity v-model="numberOfTickets" :min="0" :max="20" full-width size="lg" class="mb-6" />
    </div>
    <AppTextField
      v-model="message"
      full-width
      class="mb-3 md:mb-4"
      v-bind="messageAttrs"
      multiline
      rows="4"
      :error="!!errors.message"
      :placeholder="$t('string.Message')"
    />

    <AppButton variant="outlined" full-width @click="onSubmit">
      {{ $t('string.Submit') }}
    </AppButton>
  </UiModal>
</template>

<style lang="scss">
@import '@boats/ui/styles/config';

.app-modal-share {
  .ui-modal__content {
    text-align: center;
  }
}
</style>
